import React from 'react';
import { AnswerAudio } from '@ovos-media/templates/dist/sp';
import { generateUrl } from '../domains/uploads';

export default ({ file_audio_id, ...props }) => (
  <AnswerAudio
    {...props}
    textElements={props.answers.map(textElement => ({
      id: textElement.id,
      audioSource: generateUrl(textElement.file_audio_id),
    }))}
  />
);